module.exports = __webpack_public_path__ + "img/carl-shurz.1cf62c38.png";